import NamePlateComponent from "@/components/dashboard/general/svgs/NamePlateComponent";
import { LATEST_SHIELDS_QUERY } from "@/graphql/queries/shieldQueries";
import { useQuery } from "@apollo/client";
import React from "react";
import { useParams } from "react-router-dom";

const LatestShieldPage: React.FC = () => {
    const { position } = useParams<{ position: string }>();
    const positionIndex =
        Math.max(1, Math.min(5, parseInt(position ?? "1", 10))) - 1;

    const { data, loading, error } = useQuery(LATEST_SHIELDS_QUERY, {
        variables: { count: 5 },
        fetchPolicy: "cache-and-network",
        pollInterval: 10000,
    });

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

    const shields: Array<{
        id: string;
        imageUrl: string;
        shieldNumber: string;
        playerName: string | null;
    }> = data?.latestShields ?? [];

    const shield = shields[positionIndex];

    if (!shield) return <p>No shield data available.</p>;

    return (
        <div className="relative inline-block">
            <img src={shield.imageUrl} alt="Shield" className="w-[401px]" />
            <NamePlateComponent
                text={shield.playerName ?? ""}
                className="absolute -bottom-1 left-1/2 z-10 max-w-full -translate-x-1/2 transform"
            />
        </div>
    );
};

export default LatestShieldPage;
